module.exports = __webpack_public_path__ + "static/media/background2.f4b6a714.jpg";